<template>
  <el-popover placement="bottom" v-model="visible" ref="elPopover" popper-class="rich-text-popover">
    <div ref="popoverContainer" class="rich-text-popover-container">
      <EditableBox
        ref="editableBox"
        :mode="mode"
        :includeBtns="['confirm', 'edit']"
        @onEdit="handelEdit"
        @onAdd="handleAdd"
        @onDelete="handleDelete"
        @onConfirm="hanldeConfirm"
      >
        <template slot-scope="scope">
          <template v-if="scope.isEdit">
            <editor-input :image-style="imageStyle" v-model="inputValue" @onBlur="hanldeConfirm" hideEditorBtn>
            </editor-input>
          </template>
          <render-html v-else-if="isEditorValue" :editor-data="richTextData.data"></render-html>
          <template v-else>
            {{ richTextData }}
          </template>
        </template>
      </EditableBox>
    </div>
  </el-popover>
</template>

<script>
import EditableBox from "../EditableBox/index.jsx";
import EditorInput from "../EditorInput.vue";
import RenderHtml from "@/views/editor/simple-editor/RenderHtml.jsx";
export default {
  name: "RichTextDialog",
  components: {
    EditableBox,
    EditorInput,
    RenderHtml
  },
  props: {
    mode: String,
    editorData: {
      type: [String, Object],
      default: () => ({})
    }
  },
  data() {
    return {
      id: "",
      visible: false,
      richTextData: "富文本内容",
      imageStyle: {},
      inputValue: ""
    };
  },
  computed: {
    isEditorValue() {
      return (
        typeof this.richTextData !== "string" && this.richTextData.type && this.richTextData.type === "simpleEditor"
      );
    }
  },

  mounted() {
    window.addEventListener("mouseup", this.checkOtherArea);
  },
  beforeDestory() {
    window.removeEventListener("mouseup", this.checkOtherArea);
  },

  methods: {
    // 检查是否点击其他区域
    checkOtherArea(e) {
      if (this.$refs && this.$refs.popoverContainer && !this.$refs.popoverContainer.parentNode.contains(e.target)) {
        this.visible = false;
      }
    },
    open(id, data) {
      // console.log(id, data);
      // 从dom移除
      const popoverDom = document.getElementById(this.$refs.elPopover.tooltipId);
      // console.log(this.$refs.elPopover, popoverDom);
      if (popoverDom) {
        this.visible = false;
        // popoverDom.remove();
      }

      this.$nextTick(() => {
        this.id = id;
        this.richTextData = data || "富文本内容";
        this.inputValue = data || "富文本内容";
        this.$refs.elPopover.referenceElm = document.querySelector(`[data-button-id="${id}"]`);
        this.visible = true;
      });
    },
    close() {
      this.visible = false;
    },
    handelEdit() {},
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    hanldeConfirm() {
      const editorData = JSON.parse(JSON.stringify(this.editorData));
      const data = editorData.data;
      data.forEach(item => {
        item.children.forEach(child => {
          if (child.type === "button" && child.id === this.id) {
            child.data = this.inputValue;
          }
        });
      });
      this.richTextData = this.inputValue;
      this.$emit("onChange", editorData);
    }
  }
};
</script>

<style lang="less" scoped>
.rich-text-popover {
  max-width: 80%;
}
</style>
